import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import TrackOrder from "../components/OrderTracking";
import ScrollToTop from "react-scroll-to-top";
const TrackOrderPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
    
        <TrackOrder />
     
    </CartProvider>
  );
};
export default TrackOrderPage;
